import { Helmet } from 'react-helmet-async';

export const Head = ({ title = '', description = '' }) => {
  return (
    <Helmet
      title={title ? `${title} | Shopitrade` : undefined}
      defaultTitle='Shopitrade'
    >
      <meta name='description' content={description} />
    </Helmet>
  );
};
